// Money amount field. Shows the value with a $ prefix and hands back the bare
// number string, so a caller never deals with the decoration

import Input from './Input';

// Everything a dollar amount may look like while it is being typed: digits, an
// optional dot, at most cents. A keystroke that breaks this is dropped, which
// is what makes the field safe to use without a validation schema behind it
const amountRe = /^\d*\.?\d{0,2}$/;

export default function InputMoney({
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onClear,
  placeholder = 'Amount',
  error,
  className,
  small,
  disabled,
}) {
  const handleChange = (e) => {
    const raw = e.target.value.replace(/[$\s]/g, '');
    // A comma is a decimal separator when it stands alone, and a thousands
    // separator once a dot has claimed that role — so a pasted `1,200.00`
    // survives instead of being dropped as unparseable
    const amount = raw.includes('.')
      ? raw.replace(/,/g, '')
      : raw.replace(',', '.');
    if (amountRe.test(amount)) onChange(amount);
  };

  return (
    <Input
      name={name}
      type='text'
      inputMode='decimal'
      placeholder={'$ ' + placeholder}
      // `0` is a real amount, so an empty field is the only empty rendering
      value={value === '' || value == null ? '' : '$ ' + value}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onClear={onClear}
      error={error}
      className={'input-money' + (className ? ' ' + className : '')}
      small={small}
      disabled={disabled}
    />
  );
}
